import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      // 401 é sessão expirada: reencaminhar para o login, não insistir.
      retry: (failureCount, error) =>
        !(error instanceof ApiError && (error.isUnauthenticated || error.status < 500)) &&
        failureCount < 2,
    },
    mutations: { retry: false },
  },
});
